module.exports = __webpack_public_path__ + "static/img/cwglh5.ce2dedb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cwglh5.png
// module id = zsQU
// module chunks = 0